import { Accordion, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const BonusModal = ({ data, show, handleClose }) => {
  const navigate = useNavigate();
  if (!data) return null;
  const handleClaim = () => {
    navigate("/bonus");
  };
  return (
    <>
      <Modal
        className="promotion-content"
        show={show}
        onHide={handleClose}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{data.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="left-sec"
            style={data?.id === 3 ? { top: "0px" } : {}}
          >
            <div className="img-box">
              <img src={data.imgSrc} alt={data.title} />
            </div>
          </div>

          <div className="right-sec">
            <h4 className="title">{data.title}</h4>
            <ul className="bonus-list">
              {data?.terms?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            {Boolean(data?.actionButton) && (
              <p className="claim-now" onClick={handleClaim}>
                CLAIM NOW
              </p>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BonusModal;
